import { getProductSpecsList } from '@Utils/Product';
import useTranslation from 'next-translate/useTranslation';
import { useState } from 'react';
import { Product } from 'types/Products';
import { Description, Section, SectionTitle, Table, Td, TdGray, Title, Tr } from './ProductDescription.styled';

type Props = {
  data: Product;
};
export default function ProductDescriptionSection({ data }: Props) {
  const { t, lang } = useTranslation('Product');
  const specs = getProductSpecsList(data, t, lang);

  return (
    <>
      <SectionTitle>{t('product_description')}</SectionTitle>
      <Section>
        <Title>{t('description')}</Title>
        <Description>{data.description}</Description>
        <Title>{t('specification')}</Title>
        <Table>
          {specs.map((spec) => (
            <Tr key={spec.value}>
              <TdGray>{spec.label} :</TdGray>
              <Td>{spec.value === true ? t('true') : spec.value}</Td>
            </Tr>
          ))}
        </Table>
        {/* <Title>{t('more_info')}</Title>
        <Info>{data.product_type}</Info>
        <Info>{data.product_type}</Info>
        <Info>{data.product_type}</Info>
        <Info>{data.product_type}</Info>
        <Info>{data.product_type}</Info> */}
      </Section>
    </>
  );
}
